module.exports = __webpack_public_path__ + "static/Photography-e05fb662864da628dc52156113ecf5ad.jpg";